import { NgForOf, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { JuniorPriceList } from '../../models';
import { CompanyEnum } from '../../models/company.model';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { GeneralFeeTableComponent } from '../general-fee-table/general-fee-table.component';
import { CampDatesComponent } from '../camp-dates/camp-dates.component';
import { CampsCourseTableComponent } from '../camps-course-table/camps-course-table.component';
import { JuniorCampsHeaderComponent } from '../junior-camps-header/junior-camps-header.component';
import { JuniorCampsPrivateLessonsComponent } from '../junior-camps-private-lessons/junior-camps-private-lessons.component';
import { CampsTransfersTableComponent } from '../camps-transfers-table/camps-transfers-table.component';
import { PremiumActivitiesComponent } from '../premium-activities/premium-activities.component';
import { PriceListNoteApiDto } from '@lx/shared/api';
import SubjectEnum = PriceListNoteApiDto.SubjectEnum;

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-junior-camps-price-list-data',
  imports: [
    JuniorCampsHeaderComponent,
    CampsCourseTableComponent,
    CampsTransfersTableComponent,
    CampDatesComponent,
    GeneralFeeTableComponent,
    JuniorCampsPrivateLessonsComponent,
    PremiumActivitiesComponent,
    AdditionalInfoComponent,
    NgForOf,
    NgIf,
  ],
  templateUrl: './junior-camps-price-list-data.component.html',
  styleUrls: ['./junior-camps-price-list-data.component.scss'],
})
export class JuniorCampsPriceListDataComponent {
  @Input() camps: JuniorPriceList[] | undefined;
  @Input() applicationForms = [];

  company = CompanyEnum.ALP;
  endDatesFlag = SubjectEnum.CAMP_START_END_DATES;
}
